import axios from 'axios';

export default axios.create({
    baseURL: '/app/api/tabulados/utilerias'

})